import React, { useRef, useState } from "react";
import styles from "../Videocard/Videocard.module.css";
import { motion } from "framer-motion";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import PauseIcon from "@mui/icons-material/Pause";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

function Videocard({ Video, title, subHeading, description, reverse = false }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [muted, setMuted] = useState(true);
  const [speed, setSpeed] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const videoRef = useRef(null);

  // Time formatting
  const formatTime = (time) =>
    `${Math.floor(time / 60)}:${("0" + Math.floor(time % 60)).slice(-2)}`;

  // Play Pause Handler
  const handlePlayPause = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Mute Toggle
  const toggleMute = () => {
    videoRef.current.muted = !muted;
    setMuted(!muted);
  };

  // Speed Toggle
  const toggleSpeed = () => {
    const newSpeed = speed === 1 ? 2 : 1;
    videoRef.current.playbackRate = newSpeed;
    setSpeed(newSpeed);
  };

  return (
    <div className={`container-fluid ${styles.ColourContainer} pb-5`}>
      <div className={`row ${reverse ? "flex-row-reverse" : ""}`}>
        {/* Video Section */}
        <div className={`col-12 col-md-6 ${styles.videoWrapper}`}>
          {/* 🆕 Video Container to Track Height */}
          <div className={styles.videoBox}>
            <video
              className={styles.customVideo}
              ref={videoRef}
              muted={muted}
              playsInline
              onTimeUpdate={() => setCurrentTime(videoRef.current.currentTime)}
              onLoadedMetadata={() => setDuration(videoRef.current.duration)}
              onEnded={() => setIsPlaying(false)} // 🔥 added
            >
              <source src={Video} type="video/mp4" />
            </video>

            {/* 🔴 Play Button */}
            <button
              className={`${styles.custom_play_button} ${
                isPlaying ? styles.hideOnPlay : ""
              }`}
              onClick={handlePlayPause}
            >
              {isPlaying ? (
                <PauseIcon style={{ fontSize: "40px" }} />
              ) : (
                <ArrowRightIcon style={{ fontSize: "80px" }} />
              )}
            </button>

            {/* 🎚 Bottom Controls + Progress Combined */}
            <div className={styles.bottomControls}>
              <div className={styles.progressBarContainer}>
                <div
                  className={styles.progressBar}
                  style={{ width: `${(currentTime / duration) * 100}%` }}
                ></div>
              </div>

              <div className={styles.videoControls}>
                <button onClick={toggleMute}>
                  {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                </button>

                <span className={styles.timeText}>
                  {formatTime(currentTime)} / {formatTime(duration)}
                </span>
                {/* 
                <button onClick={toggleSpeed} className={styles.speedBtn}>
                  {speed}x
                </button> */}

                <button onClick={() => videoRef.current.requestFullscreen()}>
                  <FullscreenIcon />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="col-12 col-md-6 ">
          <div className={`card-body py-3 ${styles.cardBody}`}>
            <motion.h5
              className={`card-title main_heading ${styles.cardTitle}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {title}
            </motion.h5>

            {subHeading && (
              <motion.h5
                className={`main_subheading mb-3`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                {subHeading}
              </motion.h5>
            )}

            <motion.div
              className={`card-text p-0 ${styles.cardText}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              {Array.isArray(description) ? (
                description.map((para) => (
                  <p className="main_paragraph" key={para.id}>
                    {para.text}
                  </p>
                ))
              ) : (
                <p className="main_paragraph">{description}</p>
              )}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Videocard;
